export const BLOCK_TYPE_FAQ_LIST_SELECTION = 'faq-list-selection';
